module.exports = __webpack_public_path__ + "static/media/artificial_intelligence_img.716db68d.png";